module.exports = __webpack_public_path__ + "35ddc687683559a24b3d0642779e6457.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-21.png
// module id = 2667
// module chunks = 0